import { Translatable } from '@app/types/translatable.type';
import { QuestionTypeDisplayOptions } from '@app/types/translatables/question-type-display.options';

export interface JobQuestionTypes {
    typeName: Translatable;
    jobPostingQuestionTypeId: number;
    description: Translatable;
    fieldType: string;
}

export const jobQuestionTypes: JobQuestionTypes[] = [
    {
        typeName: 'Single line',
        jobPostingQuestionTypeId: 4,
        description: 'For questions that need short responses',
        fieldType: 'input',
    },
    {
        typeName: 'Multi line',
        jobPostingQuestionTypeId: 3,
        description: 'For questions that need long responses',
        fieldType: 'textarea',
    },
    {
        typeName: 'Number',
        jobPostingQuestionTypeId: 2,
        description: 'When the answer needs to be a number',
        fieldType: 'number',
    },
    {
        typeName: 'Date',
        jobPostingQuestionTypeId: 1,
        description: 'When the answer needs to be a date',
        fieldType: 'date',
    },
];

export const jobPostingType: { [key: number]: Translatable } = {
    1: QuestionTypeDisplayOptions['Date'],
    2: QuestionTypeDisplayOptions['Number'],
    3: QuestionTypeDisplayOptions['Multi line'],
    4: QuestionTypeDisplayOptions['Single line'],
};
